import React, {useEffect, useRef, useState} from "react";
import {useLocation, useNavigate} from "react-router-dom";
import axios from "axios";
import toast, {Toaster} from "react-hot-toast";
import DatePicker from "react-datepicker";
import {Accordion, Button} from "react-bootstrap";
import {Block} from "../block/Block";
import {Col, Row} from "../grid/Grid";
import {PreviewAltCard} from "../preview/Preview";
import {Icon, TooltipComponent} from "../Component";
import {DepositBarChart} from "../partials/charts/invest/InvestChart";
import {DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown} from "reactstrap";
import ReactTooltip from 'react-tooltip';
import {
    LineChart,
    LineChart1,
    LineChart2,
    LineChart3,
    LineChart5,
    LineChart6,
    LineChart8, LineChart9
} from "../partials/charts/default/Charts";
import {
    ActiveUserBarChart,
    AudienceLineChart2,
    AudienceLineChart3, AudienceLineChart4,
    TCDoughnut
} from "../partials/charts/analytics/AnalyticsCharts";

const AdvanceDashboardWeekly = ()=>{

    let client = null;

    const [selectedMetric, setSelectedMetric] = useState("Cash Deposit");
    const today = new Date();
    const sevenDaysAgo = new Date();
    sevenDaysAgo.setDate(today.getDate() - 7);

    const [startDate, setStartDate] = useState(sevenDaysAgo); // default to today
    const [endDate, setEndDate] = useState(today); //  default to 7 days ago
    const [totalVisitor,setTotalVisitors] = useState(0);
    const [totalServed,setTotalServed] = useState(0);
    const [totalNoShow,setTotalNoShow] = useState(0);
    const [dailyTotalVisitors,setDailyTotalVisitors] = useState([]);
    const [avgServiceTime,setAvgServiceTime] = useState(0);
    const [dailyAvgServiceTime,setDailyAvgServiceTime] = useState([])
    const [avgWaitTime,setAvgWaitTime] = useState(0);
    const [dailyAvgWaitTime,setDailyAvgWaitTime] = useState([])
    const [selectedServices,setSelectedServices] = useState(null);
    const [serviceUsers,setServiceUsers] = useState(0);
    const [serviceWaitTimeAvg,setServiceWaitTimeAvg] = useState(0);
    const [visitorData, setVisitorData] = useState([]);
    const [allService,setService] = useState([]);
    const [selectedServiceName, setSelectedServiceName] = useState("");


    const [spent,setSpent] = useState(0);
    const [serviceE,setServiceE] = useState(0);
    const [waitE,setWaitE] = useState(0);
    const [spentHourly, setSpentHourly] = useState([]);
    const [dailyVisitorData, setDailyVisitorData] = useState([]);
    const  [serviceByHourly,setServiceByHourly] = useState([]);
    const  [waitExceptionHourly,setWaitExceptionHourly] = useState([]);
    const  [serviceExceptionHourly,setServiceExceptionHourly] = useState([]);
    const [serviceException, setServiceException] = useState([]);
    const [waitingException, setWaitingException] = useState([]);
    const [spentTime,setSpentTime] = useState([]);
    const [selectedFunctionName, setSelectedFunctionName] = useState("");



    const serviceFunctionMap = [
        { label: "Issued Ticket", value: 1 },
        { label: "Served Ticket", value: 2 },
        { label: "Waiting Exception", value: 3 },
        { label: "Service Exception", value: 4 },
        { label: "Avg Spent Time", value: 5 },
    ];

    const [selectFunction, setFunction] = useState(serviceFunctionMap[0].value);
    // const data1 = {
    //     labels: test,
    //     datasets: [
    //         {
    //             label: selectedMetric,
    //             data: sampleData[selectedMetric],
    //             fill: true,
    //             borderColor: 'rgba(102, 16, 242, 0.8)',
    //             backgroundColor: 'rgba(102, 16, 242, 0.1)',
    //             tension: 0.3,
    //         }
    //     ]
    // };
    //
    // const options1 = {
    //     responsive: true,
    //     plugins: {
    //         legend: { display: false },
    //     },
    //     scales: {
    //         y: {
    //             beginAtZero: true,
    //             ticks: {
    //                 callback: value => value.toLocaleString()
    //             }
    //         }
    //     }
    // };
    let configs = JSON.parse(localStorage.getItem("configuration_data"));
    let userDetails = JSON.parse(localStorage.getItem("user_details"));
    const location = useLocation();
    const [sticky, setSticky] = useState(false);
    const [selectedBranchName, setSelectedBranchName] = useState(null);

    const userBranchId = userDetails['bid'];
    const userBranchName = userDetails['branchName'];
    const userBranchLevel = userDetails['branchLevel'];
    const userBranchQType = userDetails['queueTypeId'];
    const refChartValue = useRef(0)
    //mqtt
    const [messageArrived, setMessageArrived] = useState(false)
    const [messageData, setMessageData] = useState('')
    const [messageIncLobby, setMessageIncLobby] = useState('')
    const [messageInc1000, setMessageInc1000] = useState('')
    const [messageInc1001, setMessageInc1001] = useState('')
    const [messageInc1002, setMessageInc1002] = useState('')
    const [messageInc1010, setMessageInc1010] = useState('')
    const [messageInc1011, setMessageInc1011] = useState('')
    const [messageInc2000, setMessageInc2000] = useState('')
    const [messageInc2001, setMessageInc2001] = useState('')
    const [messageInc3000, setMessageInc3000] = useState('')
    const [messageInc3001, setmessageInc3001] = useState('')
    const [messageInc9999, setMessageInc9999] = useState('')
    const [messageInc9998, setMessageInc9998] = useState('')
    const [messageInc4000, setMessageInc4000] = useState('')
    const [allDataLoaded, setAllDataLoaded] = useState(false);
    const [country, setCountry] = useState({});
    const [selectedCountry, setselectedCountry] = useState(null)
    const [province, setprovince] = useState({});
    const [provinces, setProvinces] = useState([]);
    const [selectedProvince, setselectedProvince] = useState(null);
    const [district, setdistrict] = useState({});
    const [districts, setDistricts] = useState([]);
    const [selectedDistrict, setselectedDistrict] = useState(null);
    const [userBranch, setuserBranch] = useState({});
    const [branches, setBranches] = useState([]);
    const [selectedUserBranch, setSelectedUserBranch] = useState(null)
    const baseUrl = localStorage.getItem('API_URL');
    const token = localStorage.getItem('user_token');
    const [selectedBranchId, setSelectedBranchId] = useState(null);
    const [selectedBranchLevel, setSelectedBranchLevel] = useState(null);
    const [selectedBranchQueueType, setSelectedBranchQueueType] = useState(null);
    const [serviceDataLoaded, setServiceDataLoaded] = useState(false);
    const [functionData,setFunctionData] = useState([]);
    const [functionData1,setFunctionData1] = useState([]);

    const history = useNavigate();
    const [branchSqeuenceData, setBranchSqeuenceData] = useState({});
    const renderFunction = () => {
        if (location.state !== null) {
            setSelectedBranchId(location.state.selectedBranchId);
            setSelectedBranchName(location.state.selectedBranchName);
            setSelectedBranchLevel(location.state.selectedBranchLevel);
            setSelectedBranchQueueType(location.state.selectedBranchQueueType);
        } else {
            setSelectedBranchId(userBranchId);
            setSelectedBranchName(userBranchName);
            setSelectedBranchLevel(userBranchLevel);
            setSelectedBranchQueueType(userBranchQType);
        }
    }
    const [selectedDate, setSelectedDate] = useState(null);


    const setMessages = (messageData) => {
        if (messageData === '1') {
            setMessageIncLobby(new Date().toString())
        } else if (messageData === '1000') {
            setMessageInc1000(new Date().toString());
        } else if (messageData === '1001') {
            setMessageInc1001(new Date().toString());
        } else if (messageData === '1002') {
            setMessageInc1002(new Date().toString());
        } else if (messageData === '9999') {
            setMessageInc9999(new Date().toString());
        } else if (messageData === '2000') {
            setMessageInc2000(new Date().toString());
        } else if (messageData === '2001') {
            setMessageInc2001(new Date().toString());
        } else if (messageData === '3000') {
            setMessageInc3000(new Date().toString());
        } else if (messageData === '3001') {
            setmessageInc3001(new Date().toString());
        } else if (messageData === '1010') {
            setMessageInc1010(new Date().toString());
        } else if (messageData === '1011') {
            setMessageInc1011(new Date().toString());
        } else if (messageData === '9998') {
            setMessageInc9998(new Date().toString());
        }
    }
    const navigateToBranchTables = (selectedBranchId, selectedBranchName, selectedBranchLevel, selectedBranchQueueType) => {
        history('/branch-tables-page', {
            state: {
                selectedBranchId: selectedBranchId,
                selectedBranchName: selectedBranchName,
                selectedBranchLevel: selectedBranchLevel,
                selectedBranchQueueType: selectedBranchQueueType
            }
        });
    }
    const executeFunctions = (messageData) => {
        if (selectedBranchId !== null) {

            getBranchSequence();
            if (messageData === null || messageData === '') {



            } else {

                console.info("message data: ", messageData)
                setMessages(messageData);

                // if (messageData === "1000" ||
                //     messageData === '1001') {
                //     noSkillTicketsDetails();
                // }

                if (messageData === '1' ||
                    messageData === '1000' ||
                    messageData === '1001' ||
                    messageData === '1002' ||
                    messageData === '2001' ||
                    messageData === '3000' ||
                    messageData === '3001' ||
                    messageData === '9998' ||
                    messageData === '9999') {

                }

                if (messageData === '1000' ||
                    messageData === '1001') {

                }

                if (messageData === '1001') {

                }

                // if (messageData === '1000' ||
                //     messageData === '1001') {
                //     getWaitingTicketDetails();
                // }

                // if (messageData === '1000' ||
                //     messageData === '1001' ||
                //     messageData === '2000' ||
                //     messageData === '2001' ||
                //     messageData === '3001') {
                //     getTicketDetailsByBranch();
                // }

                if (messageData === '1001') {

                }

                if (messageData === '1000' ||
                    messageData === '1001' ||
                    messageData === '2000' ||
                    messageData === '2001' ||
                    messageData === '3000' ||
                    messageData === '3001') {

                }

                if (messageData === '1001') {

                }

                if (messageData === '1001' ||
                    messageData === '1010' ||
                    messageData === '1011' ||
                    messageData === '9999') {

                }
            }
        }
    }

    const  formatDate = (date) => {
        if(date != null) {
            return date.toISOString().split("T")[0]; // e.g. "2025-04-24"
        }
    };




    const getBranchSequence = () => {
        // userDetails['userType']
        axios({
            method: 'GET',
            url: `${baseUrl}/branch/get-sequence/branch/${selectedBranchId}`,
            headers: {
                Authorization: token
            }
        }).then((res) => {

            console.log('getBranchSequence success');
            let data = res.data.data;
            setBranchSqeuenceData(data);

            if (data.countryId !== undefined) {
                setselectedCountry(data.countryId);
                getCountry(data.countryId);
                getProvinces(data.countryId, data.provinceId);
            }

            if (data.provinceId !== undefined) {
                setselectedProvince(data.provinceId);
                getDistricts(data.provinceId, data.districtId);
            }

            if (data.districtId !== undefined) {
                setselectedDistrict(data.districtId)
                getBranches(data.districtId);
            }

            if (data.branchId !== undefined) {
                setSelectedUserBranch(data.branchId);
            }

        }).catch((error) => {
            console.log('getBranchSequence error');
            console.log(error);

            if (error.response !== undefined) {
                toast.remove();
                toast.error(error.response.data.message, {
                    position: 'bottom-center',
                });
            } else {
                toast.remove();
                toast.error('Something went wrong', {
                    position: 'bottom-center',
                });
            }

        })
    }

    const getCountry = (country) => {
        axios({
            method: 'GET',
            url: `${baseUrl}/branch/get-branch/${country}`,
            headers: {
                Authorization: token
            }
        }).then((res) => {

            console.log('getCountry success');
            let data = res.data.data;
            setCountry(data);

        }).catch((error) => {
            console.log('getCountry error');
            console.log(error);

            if (error.response !== undefined) {
                toast.remove();
                toast.error(error.response.data.message, {
                    position: 'bottom-center',
                });
            } else {
                toast.remove();
                toast.error('Something went wrong', {
                    position: 'bottom-center',
                });
            }

        })
    }

    const getProvinces = (country, province) => {

        let url = ``;

        if (userDetails['branchLevel'] === 1) {

            url = `${baseUrl}/branch/get-all/parent-branch/${country}`;

        } else if (userDetails['branchLevel'] === 3 || userDetails['branchLevel'] === 4) {

            url = `${baseUrl}/branch/get-branch/${province}`

        } else {

            url = `${baseUrl}/branch/get-branch/${userDetails['bid']}`;

        }

        axios({
            method: 'GET',
            url: url,
            headers: {
                Authorization: token
            }
        }).then((res) => {

            console.log('getProvinces success');
            let data = res.data.data;
            console.log("province data: ", data);
            if (userDetails['branchLevel'] === 1) {
                setProvinces(data);
            } else {
                setprovince(data);
            }

        }).catch((error) => {
            console.log('getProvinces error');
            console.log(error);

            if (error.response !== undefined) {
                toast.remove();
                toast.error(error.response.data.message, {
                    position: 'bottom-center',
                });
            } else {
                toast.remove();
                toast.error('Something went wrong', {
                    position: 'bottom-center',
                });
            }

        })
    }

    const getDistricts = (province, district) => {
        let url = ``;

        if (userDetails['branchLevel'] === 1 || userDetails['branchLevel'] === 2) {

            url = `${baseUrl}/branch/get-all/parent-branch/${province}`;

        } else if (userDetails['branchLevel'] === 4) {

            url = `${baseUrl}/branch/get-branch/${district}`

        } else {

            url = `${baseUrl}/branch/get-branch/${userDetails['bid']}`;

        }

        axios({
            method: 'GET',
            url: url,
            headers: {
                Authorization: token
            }
        }).then((res) => {

            console.log('getDistricts success');
            let data = res.data.data;

            if (userDetails['branchLevel'] === 1
                || userDetails['branchLevel'] === 2) {
                setDistricts(data);
            } else {
                setdistrict(data);
            }

        }).catch((error) => {
            console.log('getDistricts error');
            console.log(error);

            if (error.response !== undefined) {
                toast.remove();
                toast.error(error.response.data.message, {
                    position: 'bottom-center',
                });
            } else {
                toast.remove();
                toast.error('Something went wrong', {
                    position: 'bottom-center',
                });
            }

        })
    }

    const getBranches = (district) => {
        let url = ``;

        if (userDetails['branchLevel'] === 4) {
            url = `${baseUrl}/branch/get-branch/${userDetails['bid']}`;
        } else {
            url = `${baseUrl}/branch/get-all/parent-branch/${district}`;
        }

        axios({
            method: 'GET',
            url: url,
            headers: {
                Authorization: token
            }
        }).then((res) => {

            console.log('getBranches success');
            let data = res.data.data;

            if (userDetails['branchLevel'] === 4) {
                setuserBranch(data);
            } else {
                if (data !== null) {
                    setBranches(data);
                }
            }

        }).catch((error) => {
            console.log('getBranches error');
            console.log(error);

            if (error.response !== undefined) {
                toast.remove();
                toast.error(error.response.data.message, {
                    position: 'bottom-center',
                });
            } else {
                toast.remove();
                toast.error('Something went wrong', {
                    position: 'bottom-center',
                });
            }

        })
    }


    const getVisitors = () => {
        const formattedDate = formatDate(startDate);
        const formattedDateEnd = formatDate(endDate);

        axios({
            method: 'GET',
            url: `${baseUrl}/dashboard/getAllVisitors-weekly/${selectedBranchId}/${formattedDate}/${formattedDateEnd}`,
            headers: {
                Authorization: token
            }
        }).then((res) => {

          setTotalVisitors(res.data);
        }).catch((err) => {
            console.error(err);
        });
    };

    const getTotalServed = () => {
        const formattedDate = formatDate(startDate);
        const formattedDateEnd = formatDate(endDate);

        axios({
            method: 'GET',
            url: `${baseUrl}/dashboard/getTotalServed-weekly/${selectedBranchId}/${formattedDate}/${formattedDateEnd}`,
            headers: {
                Authorization: token
            }
        }).then((res) => {

            setTotalServed(res.data);
        }).catch((err) => {
            console.error(err);
        });
    };
    const getTotalNoShow = () => {
        const formattedDate = formatDate(startDate);
        const formattedDateEnd = formatDate(endDate);

        axios({
            method: 'GET',
            url: `${baseUrl}/dashboard/getTotalNoShow-weekly/${selectedBranchId}/${formattedDate}/${formattedDateEnd}`,
            headers: {
                Authorization: token
            }
        }).then((res) => {

            setTotalNoShow(res.data);
        }).catch((err) => {
            console.error(err);
        });
    };

    const getTotalVisitorsDaily = () => {
        const formattedDate = formatDate(startDate);
        const formattedDateEnd = formatDate(endDate);

        axios({
            method: 'GET',
            url: `${baseUrl}/dashboard/getTotalVisitors-daily/${selectedBranchId}/${formattedDate}/${formattedDateEnd}`,
            headers: {
                Authorization: token
            }
        }).then((res) => {

            setDailyTotalVisitors(res.data);
        }).catch((err) => {
            console.error(err);
        });
    };


    const getAvgServiceTime = () => {
        const formattedDate = formatDate(startDate);
        const formattedDateEnd = formatDate(endDate);

        axios({
            method: 'GET',
            url: `${baseUrl}/dashboard/getAvgServiceTime-weekly/${selectedBranchId}/${formattedDate}/${formattedDateEnd}`,
            headers: {
                Authorization: token
            }
        }).then((res) => {

            setAvgServiceTime(res.data);
        }).catch((err) => {
            console.error(err);
        });
    };

    const getDailyAvgServiceTime = () => {
        const formattedDate = formatDate(startDate);
        const formattedDateEnd = formatDate(endDate);

        axios({
            method: 'GET',
            url: `${baseUrl}/dashboard/getAvgServiceTime-daily/${selectedBranchId}/${formattedDate}/${formattedDateEnd}`,
            headers: {
                Authorization: token
            }
        }).then((res) => {

            setDailyAvgServiceTime(res.data);
        }).catch((err) => {
            console.error(err);
        });
    };

    const getAvgWaitTime = () => {
        const formattedDate = formatDate(startDate);
        const formattedDateEnd = formatDate(endDate);

        axios({
            method: 'GET',
            url: `${baseUrl}/dashboard/getAvgWaitTime-weekly/${selectedBranchId}/${formattedDate}/${formattedDateEnd}`,
            headers: {
                Authorization: token
            }
        }).then((res) => {

            setAvgWaitTime(res.data);
        }).catch((err) => {
            console.error(err);
        });
    };

    const getDailyAvgWaitTime = () => {
        const formattedDate = formatDate(startDate);
        const formattedDateEnd = formatDate(endDate);

        axios({
            method: 'GET',
            url: `${baseUrl}/dashboard/getAvgWaitTime-daily/${selectedBranchId}/${formattedDate}/${formattedDateEnd}`,
            headers: {
                Authorization: token
            }
        }).then((res) => {

            setDailyAvgWaitTime(res.data);
        }).catch((err) => {
            console.error(err);
        });
    };

    const getServices = () => {
        axios({
            method: 'GET',
            url: `${baseUrl}/dashboard/getAllService/${selectedBranchId}`,
            headers: {
                Authorization: token
            }
        }).then((res) => {
            let services = res.data;
            if (services.length > 0) {
                // Add "All" option at the beginning
                services = [{ id: -1, name: "All Services" }, ...services];
                setService(services);
                setSelectedServices(-1); // Auto-select "All"
            } else {
                setService([]);
                setSelectedServices(null);
            }
        }).catch((err) => {
            console.error(err);
        });
    };



    const getServiceWaitTimeAndVisitors = () => {
        const formattedDate = formatDate(startDate);
        const formattedDateEnd = formatDate(endDate);

        axios({
            method: 'GET',
            url: `${baseUrl}/dashboard/getServiceWaitTime-visitors-weekly/${selectedBranchId}/${formattedDate}/${selectedServices}/${formattedDateEnd}`,
            headers: {
                Authorization: token
            }
        }).then((res) => {

            const [awaitTime, users, spent, waitE, serviceE] = res.data;

            setServiceUsers(users);
            setServiceUsers(users);
            setServiceWaitTimeAvg(awaitTime);
            setSpent(spent);
            setWaitE(waitE);
            setServiceE(serviceE);

        }).catch((err) => {
            console.error(err);
        });
    };


    const getServiceWaitTimeAndVisitorss = async () => {
        const formattedDate = formatDate(selectedDate);

        try {
            const res = await axios.get(
                `${baseUrl}/dashboard/getServiceWaitTime-visitors/${selectedBranchId}/${formattedDate}/${selectedServices}`,
                {
                    headers: {
                        Authorization: token,
                    },
                }
            );

            const [awaitTime, users, spent, waitE, serviceE] = res.data;

            setServiceUsers(users);
            setServiceWaitTimeAvg(awaitTime);
            setSpent(spent);
            setWaitE(waitE);
            setServiceE(serviceE);
        } catch (err) {
            console.error("Error in getServiceWaitTimeAndVisitors:", err);
        }
    };

    const getServiceWaitTimeAndVisitorsOverview = async () => {
        const formattedDate = formatDate(startDate);
        const formattedDateEnd = formatDate(endDate);
        try {
            const res = await axios.get(
                `${baseUrl}/dashboard/getServiceWaitTime-visitors-overview-weekly/${selectedBranchId}/${formattedDate}/${selectedServices}/${formattedDateEnd}/1`,
                { headers: { Authorization: token } }
            );
            setVisitorData(res.data);
            console.log(res.data);
        } catch (err) {
            console.error("getServiceWaitTimeAndVisitorsOverview error:", err);
        }
    };

    const getServiceWaitTimeAndVisitorsOverviewSpentTime = async () => {
        const formattedDate = formatDate(startDate);
        const formattedDateEnd = formatDate(endDate);
        try {
            const res = await axios.get(
                `${baseUrl}/dashboard/getServiceWaitTime-visitors-overview-weekly/${selectedBranchId}/${formattedDate}/${selectedServices}/${formattedDateEnd}/5`,
                { headers: { Authorization: token } }
            );
            setSpentHourly(res.data);
            console.log(res.data);
        } catch (err) {
            console.error("getServiceWaitTimeAndVisitorsOverviewSpentTime error:", err);
        }
    };

    const getServiceTimeByServices = async () => {
        const formattedDate = formatDate(startDate);
        const formattedDateEnd = formatDate(endDate);
        try {
            const res = await axios.get(
                `${baseUrl}/dashboard/getServiceWaitTime-visitors-overview-weekly/${selectedBranchId}/${formattedDate}/${selectedServices}/${formattedDateEnd}/2`,
                { headers: { Authorization: token } }
            );
            setServiceByHourly(res.data);
            console.log(res.data);
        } catch (err) {
            console.error("getServiceTimeByServices error:", err);
        }
    };

    const getWaitTimeExceptionHourly = async () => {
        const formattedDate = formatDate(startDate);
        const formattedDateEnd = formatDate(endDate);
        try {
            const res = await axios.get(
                `${baseUrl}/dashboard/getServiceWaitTime-visitors-overview-weekly/${selectedBranchId}/${formattedDate}/${selectedServices}/${formattedDateEnd}/3`,
                { headers: { Authorization: token } }
            );
            setWaitExceptionHourly(res.data);
            console.log(res.data);
        } catch (err) {
            console.error("getWaitTimeExceptionHourly error:", err);
        }
    };

    const getServiceTimeExceptionHourly = async () => {
        const formattedDate = formatDate(startDate);
        const formattedDateEnd = formatDate(endDate);
        try {
            const res = await axios.get(
                `${baseUrl}/dashboard/getServiceWaitTime-visitors-overview-weekly/${selectedBranchId}/${formattedDate}/${selectedServices}/${formattedDateEnd}/4`,
                { headers: { Authorization: token } }
            );
            setServiceExceptionHourly(res.data);
            console.log(res.data);
        } catch (err) {
            console.error("getServiceTimeExceptionHourly error:", err);
        }
    };


    const getServiceException= () => {
        const formattedDate = formatDate(startDate);
        const formattedDateEnd = formatDate(endDate);

        axios({
            method: 'GET',
            url: `${baseUrl}/dashboard/getAllServiceException-weekly/${selectedBranchId}/${formattedDate}/${formattedDateEnd}`,
            headers: {
                Authorization: token
            }
        }).then((res) => {


            setServiceException(res.data);

        }).catch((err) => {
            console.error(err);
        });
    }

    const getWaitingException= () => {
        const formattedDate = formatDate(startDate);
        const formattedDateEnd = formatDate(endDate);
        axios({
            method: 'GET',
            url: `${baseUrl}/dashboard/getAllWaitException-weekly/${selectedBranchId}/${formattedDate}/${formattedDateEnd}`,
            headers: {
                Authorization: token
            }
        }).then((res) => {


            setWaitingException(res.data);

        }).catch((err) => {
            console.error(err);
        });
    }

    const getSpentTime= () => {
        const formattedDate = formatDate(startDate);
        const formattedDateEnd = formatDate(endDate);

        axios({
            method: 'GET',
            url: `${baseUrl}/dashboard/getAllSpentTime-weekly/${selectedBranchId}/${formattedDate}/${formattedDateEnd}`,
            headers: {
                Authorization: token
            }
        }).then((res) => {


            setSpentTime(res.data);

        }).catch((err) => {
            console.error(err);
        });
    }

    const getFunctionData = () => {


        const formattedDate = formatDate(startDate);
        const formattedDateEnd = formatDate(endDate);

        const startDate1 = new Date(startDate);
        const endDate1 = new Date(endDate);

        // Calculate the difference in days
        const diffMs = endDate1 - startDate1;
        const diffDays = diffMs / (1000 * 60 * 60 * 24);

        const fromDate1Date = new Date(startDate);
        fromDate1Date.setDate(startDate.getDate() - diffDays);

        const fromDate1 = formatDate(fromDate1Date);
        const fromDate2 = formatDate(startDate);

        // Clear previous data
        setFunctionData([]);
        setFunctionData1([]);

        axios({
            method: 'GET',
            url: `${baseUrl}/dashboard/getFunctionData-weekly/${selectedBranchId}/${fromDate1}/${fromDate2}/${selectedServices}/${selectFunction}`,
            headers: {
                Authorization: token
            }
        }).then((res) => {
            setFunctionData(res.data);




            if (selectFunction === 1) {

                setFunctionData1(visitorData);

            } else if (selectFunction === 2) {
                setFunctionData1(serviceByHourly);
            } else if (selectFunction === 3) {
                setFunctionData1(waitExceptionHourly);
            } else if (selectFunction === 4) {
                setFunctionData1(serviceExceptionHourly);
            } else if (selectFunction === 5) {
                setFunctionData1(spentHourly);
            }

            console.log(res.data);
        }).catch((err) => {
            console.error(err);
        });
    };
    useEffect(() => {
        renderFunction();

    }, [AdvanceDashboardWeekly])

    useEffect(() => {
        if (baseUrl.length > 0 && token.length > 0) {
            executeFunctions('');
        }
    }, [baseUrl, token, selectedBranchId, refChartValue])

    useEffect(() => {
        const today = new Date();
        setSelectedDate(today);
    }, []);

useEffect(()=>{
    getVisitors();
    getTotalServed();
    getTotalNoShow();
    getTotalVisitorsDaily();
    getAvgServiceTime();
    getDailyAvgServiceTime();
    getAvgWaitTime();
    getDailyAvgWaitTime();
    getServices();
    getServiceWaitTimeAndVisitors();
    getServiceException();
    getWaitingException();
    getSpentTime();

},[selectedBranchId,startDate,endDate]);


    useEffect(()=>{

        getServiceWaitTimeAndVisitors();


    },[selectedBranchId,startDate,endDate,selectedServices]);

    useEffect(() => {
        const loadServiceData = async () => {
            if (selectedServices != null) {
                setServiceDataLoaded(false); // Reset before loading

                try {
                    await Promise.all([
                        getServiceWaitTimeAndVisitors(),
                        getServiceWaitTimeAndVisitorsOverview(),
                        getServiceWaitTimeAndVisitorsOverviewSpentTime(),
                        getServiceTimeByServices(),
                        getWaitTimeExceptionHourly(),
                        getServiceTimeExceptionHourly()
                    ]);
                } catch (error) {
                    console.error("Error loading service data:", error);
                }

                setServiceDataLoaded(true); // Mark as complete
            }
        };



        loadServiceData();

        const foundService = allService.find(service => service.id === selectedServices);
        setSelectedServiceName(foundService?.name || "Unknown Service");



    }, [selectedBranchId, startDate,endDate, selectedServices]);

    useEffect(() => {
        if (selectedServices != null && serviceDataLoaded) {
            getFunctionData();

        }
        const foundFunction = serviceFunctionMap.find(service => service.value === selectFunction);
        setSelectedFunctionName(foundFunction?.label || "Unknown Function");
    }, [selectedBranchId,endDate,startDate, selectedServices, selectFunction, selectedDate, serviceDataLoaded]);

    const handleStartDateChange = (date) => {
        setStartDate(date);

        const maxDate = new Date(); // today's date
        const calculatedEndDate = new Date(date);
        calculatedEndDate.setDate(date.getDate() + 7);

        // Set endDate to either startDate + 7 or today (whichever is earlier)
        setEndDate(calculatedEndDate > maxDate ? maxDate : calculatedEndDate);
    };
    return(
        <>
            <div><Toaster/></div>
            <div
                className={`${sticky ? "block-header block-header-padding sticky" : "block-header block-header-padding"}`}>
                <div className="row clearfix">
                    <div className="col-md-6 col-sm-12">
                        <h1>Advance Branch Dashboard Weekly</h1>

                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item active" aria-current="page">{selectedBranchName}</li>
                            </ol>
                        </nav>

                    </div>


                </div>
            </div>

            <>
                {userDetails['branchLevel'] !== 4 ? (
                    <div className="row clearfix">
                        <div className="col-md-12 col-sm-8 p-l-5 p-r-5 mb-4">
                            <div className="card">
                                <div className="body">
                                    <div className="row">
                                        <div className="col-md-12 col-sm-12 p-l-5 p-r-5">
                                            <Accordion className="accordion" id="accordion">
                                                <div>
                                                    <div className="card-header " id="headingOne">
                                                        <h5 className="mb-0">
                                                            <Accordion.Toggle as={Button} variant="link"
                                                                              eventKey="0"
                                                                              className={selectedBranchLevel === 4 ? 'acc-color-branch'
                                                                                  : selectedBranchLevel === 3 ? 'acc-color-district'
                                                                                      : selectedBranchLevel === 2 ? 'acc-color-province'
                                                                                          : 'acc-color-country'}
                                                            >
                                                                {branchSqeuenceData.name}
                                                                <div className="float-right"><i
                                                                    className="fa fa-chevron-circle-down"></i></div>
                                                            </Accordion.Toggle>
                                                        </h5>
                                                    </div>
                                                    <Accordion.Collapse eventKey="0" className="collapse">
                                                        <div className="body">
                                                            <div className='row clearfix'>
                                                                <div className="col-lg-3 col-md-6 col-sm-12">
                                                                    <div className="card">
                                                                        <div
                                                                            className='taskboard b-cyan progress_task'>
                                                                            <h6 className="font300 mb-3">Country
                                                                            </h6>
                                                                            <div className="dd"
                                                                                 data-plugin="nestable">
                                                                                {userDetails['branchLevel'] === 1 ? (
                                                                                    <div
                                                                                        className={`dd-handle align-items-center ${selectedCountry === country.id ? 'active' : ''}`}
                                                                                        // key={country.id}
                                                                                        onClick={() => {
                                                                                            setselectedCountry(country.id)
                                                                                            setselectedProvince(null)
                                                                                            setselectedDistrict(null)
                                                                                            setSelectedUserBranch(null)
                                                                                            setDistricts([])
                                                                                            setBranches([])

                                                                                        }}

                                                                                    >
                                                                                        <div
                                                                                            className='d-flex justify-content-between'>
                                                                                            <div>{country.name}</div>
                                                                                            <div
                                                                                                className={selectedBranchId === country.id ? 'btn btn-prymary select-btn external-link-active'
                                                                                                    : 'btn btn-prymary select-btn'}
                                                                                                onClick={() => {
                                                                                                    setSelectedBranchId(country.id)
                                                                                                    setSelectedBranchName(country.name)
                                                                                                    setSelectedBranchLevel(country.level)
                                                                                                }}
                                                                                            >
                                                                                                <i className="fa fa-external-link float-left"></i>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                ) : (
                                                                                    <div
                                                                                        className='dd-handle align-items-center'
                                                                                        style={{cursor: 'default'}}
                                                                                    >
                                                                                        <div
                                                                                            className='d-flex justify-content-between'>
                                                                                            <div>{country.name}</div>
                                                                                        </div>
                                                                                    </div>
                                                                                )}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="col-lg-3 col-md-6 col-sm-12">
                                                                    <div className="card">
                                                                        <div
                                                                            className='taskboard b-cyan progress_task'>
                                                                            <h6 className="font300 mb-3">Province
                                                                            </h6>
                                                                            <div className="dd"
                                                                                 data-plugin="nestable">
                                                                                {provinces !== null ? (
                                                                                    <>
                                                                                        {userDetails['branchLevel'] === 1 ? (
                                                                                            <>
                                                                                                {provinces.map((data, i) =>
                                                                                                    <div
                                                                                                        className={`dd-handle align-items-center ${selectedProvince === data.id ? 'active' : ''}`}
                                                                                                        key={i}
                                                                                                        onClick={() => {
                                                                                                            setselectedProvince(data.id)
                                                                                                            setselectedDistrict(null)
                                                                                                            setSelectedUserBranch(null)
                                                                                                            setBranches([])
                                                                                                        }}
                                                                                                    >
                                                                                                        <div
                                                                                                            className='d-flex justify-content-between'>
                                                                                                            <div>{data.name}</div>
                                                                                                            <div
                                                                                                                className={selectedBranchId === data.id ? 'btn btn-prymary select-btn external-link-active'
                                                                                                                    : 'btn btn-prymary select-btn'}
                                                                                                                onClick={() => {
                                                                                                                    setSelectedBranchId(data.id)
                                                                                                                    setSelectedBranchName(data.name)
                                                                                                                    setSelectedBranchLevel(data.level)
                                                                                                                }}
                                                                                                            >
                                                                                                                <i className="fa fa-external-link float-left"></i>
                                                                                                            </div>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                )}
                                                                                            </>
                                                                                        ) : userDetails['branchLevel'] === 2 ? (
                                                                                            <div
                                                                                                className={`dd-handle align-items-center ${selectedProvince === province.id ? 'active' : ''}`}
                                                                                                onClick={() => {
                                                                                                    setselectedProvince(province.id)
                                                                                                    setselectedDistrict(null)
                                                                                                    setSelectedUserBranch(null)
                                                                                                    setBranches([])
                                                                                                }}
                                                                                            >
                                                                                                <div
                                                                                                    className='d-flex justify-content-between'>
                                                                                                    <div>{province.name}</div>
                                                                                                    <div
                                                                                                        className={selectedBranchId === province.id ? 'btn btn-prymary select-btn external-link-active'
                                                                                                            : 'btn btn-prymary select-btn'}
                                                                                                        onClick={() => {
                                                                                                            setSelectedBranchId(province.id)
                                                                                                            setSelectedBranchName(province.name)
                                                                                                            setSelectedBranchLevel(province.level)
                                                                                                        }}
                                                                                                    >
                                                                                                        <i className="fa fa-external-link float-left"></i>
                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>
                                                                                        ) : (
                                                                                            <div
                                                                                                className='dd-handle align-items-center'
                                                                                                style={{cursor: 'default'}}
                                                                                            >
                                                                                                <div
                                                                                                    className='d-flex justify-content-between'>
                                                                                                    <div>{province.name}</div>
                                                                                                </div>
                                                                                            </div>
                                                                                        )}
                                                                                    </>
                                                                                ) : (
                                                                                    <div
                                                                                        className={`dd-handle align-items-center`}>
                                                                                        <div
                                                                                            className='d-flex justify-content-between'>
                                                                                            <div> No provices
                                                                                                yet...
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                )}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                <div className="col-lg-3 col-md-6 col-sm-12">
                                                                    <div className="card">
                                                                        <div
                                                                            className='taskboard b-cyan progress_task'>
                                                                            <h6 className="font300 mb-3">District
                                                                            </h6>
                                                                            <div className="dd"
                                                                                 data-plugin="nestable">
                                                                                {userDetails['branchLevel'] === 1 || userDetails['branchLevel'] === 2 ? (
                                                                                    <>
                                                                                        {districts !== null ? (
                                                                                            <>
                                                                                                {districts.length > 0 ? (
                                                                                                    <>
                                                                                                        {districts.map((data, i) =>
                                                                                                            <div
                                                                                                                className={`dd-handle align-items-center ${selectedDistrict === data.id ? 'active' : ''}`}
                                                                                                                key={i}
                                                                                                                onClick={() => {
                                                                                                                    setselectedDistrict(data.id);
                                                                                                                    setSelectedUserBranch(null);
                                                                                                                }}
                                                                                                            >
                                                                                                                <div
                                                                                                                    className='d-flex justify-content-between'>
                                                                                                                    <div>{data.name}</div>
                                                                                                                    <div
                                                                                                                        className={selectedBranchId === data.id ? 'btn btn-prymary select-btn external-link-active'
                                                                                                                            : 'btn btn-prymary select-btn'}
                                                                                                                        onClick={() => {
                                                                                                                            setSelectedBranchId(data.id)
                                                                                                                            setSelectedBranchName(data.name)
                                                                                                                            setSelectedBranchLevel(data.level)
                                                                                                                        }}
                                                                                                                    >
                                                                                                                        <i className="fa fa-external-link float-left"></i>
                                                                                                                    </div>
                                                                                                                </div>
                                                                                                            </div>
                                                                                                        )}
                                                                                                    </>
                                                                                                ) : (<div
                                                                                                    className={`dd-handle align-items-center`}>
                                                                                                    <div
                                                                                                        className='d-flex justify-content-between'>
                                                                                                        <div> Select
                                                                                                            Provice
                                                                                                        </div>
                                                                                                    </div>
                                                                                                </div>)}
                                                                                            </>
                                                                                        ) : (<div
                                                                                            className={`dd-handle align-items-center`}>
                                                                                            <div
                                                                                                className='d-flex justify-content-between'>
                                                                                                <div> No districts
                                                                                                    yet...
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>)}
                                                                                    </>
                                                                                ) : userDetails['branchLevel'] === 3 ? (
                                                                                    <div
                                                                                        className={`dd-handle align-items-center ${selectedDistrict === district.id ? 'active' : ''}`}

                                                                                        onClick={() => {
                                                                                            setselectedDistrict(district.id);
                                                                                            setSelectedUserBranch(null);
                                                                                        }}
                                                                                    >
                                                                                        <div
                                                                                            className='d-flex justify-content-between'>
                                                                                            <div>{district.name}</div>
                                                                                            <div
                                                                                                className={selectedBranchId === district.id ? 'btn btn-prymary select-btn external-link-active'
                                                                                                    : 'btn btn-prymary select-btn'}
                                                                                                onClick={() => {
                                                                                                    setSelectedBranchId(district.id)
                                                                                                    setSelectedBranchName(district.name)
                                                                                                    setSelectedBranchLevel(district.level)
                                                                                                }}
                                                                                            >
                                                                                                <i className="fa fa-external-link float-left"></i>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                ) : (<div
                                                                                    className='dd-handle align-items-center'
                                                                                    style={{cursor: 'default'}}
                                                                                >
                                                                                    <div
                                                                                        className='d-flex justify-content-between'>
                                                                                        <div>{district.name}</div>
                                                                                    </div>
                                                                                </div>)}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="col-lg-3 col-md-6 col-sm-12">
                                                                    <div className="card">
                                                                        <div
                                                                            className='taskboard b-cyan progress_task'>
                                                                            <h6 className="font300 mb-3">Branch
                                                                            </h6>
                                                                            <div className="dd"
                                                                                 data-plugin="nestable">
                                                                                {userDetails['branchLevel'] === 1 || userDetails['branchLevel'] === 2 || userDetails['branchLevel'] === 3 ? (
                                                                                    <>
                                                                                        {branches !== null ? (
                                                                                            <>
                                                                                                {branches.length > 0 ? (
                                                                                                    <>
                                                                                                        {branches.map((data, i) =>
                                                                                                            <div
                                                                                                                className={`dd-handle align-items-center ${selectedUserBranch === data.id ? 'active' : ''}`}
                                                                                                                key={i}
                                                                                                                onClick={() => {
                                                                                                                    setSelectedUserBranch(data.id)
                                                                                                                }}
                                                                                                            >
                                                                                                                <div
                                                                                                                    className='d-flex justify-content-between'>
                                                                                                                    <div>{data.name}</div>
                                                                                                                    <div
                                                                                                                        className={selectedBranchId === data.id ? 'btn btn-prymary select-btn external-link-active' : 'btn btn-prymary select-btn'}
                                                                                                                        onClick={() => {
                                                                                                                            setSelectedBranchId(data.id)
                                                                                                                            setSelectedBranchName(data.name)
                                                                                                                            setSelectedBranchLevel(data.level)
                                                                                                                            setSelectedBranchQueueType(data.branchQueueType)
                                                                                                                        }}
                                                                                                                    >
                                                                                                                        <i className="fa fa-external-link float-left"></i>
                                                                                                                    </div>
                                                                                                                </div>
                                                                                                            </div>
                                                                                                        )}
                                                                                                    </>
                                                                                                ) : (
                                                                                                    <div
                                                                                                        className={`dd-handle align-items-center`}>
                                                                                                        <div
                                                                                                            className='d-flex justify-content-between'>
                                                                                                            <div> Select
                                                                                                                District
                                                                                                            </div>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                )}
                                                                                            </>
                                                                                        ) : (
                                                                                            <div
                                                                                                className={`dd-handle align-items-center`}>
                                                                                                <div
                                                                                                    className='d-flex justify-content-between'>
                                                                                                    <div> No
                                                                                                        branches
                                                                                                        yet...
                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>
                                                                                        )}
                                                                                    </>
                                                                                ) : userDetails['branchLevel'] === 4 ? (
                                                                                    <div
                                                                                        className={`dd-handle align-items-center ${selectedUserBranch === userBranch.id ? 'active' : ''}`}
                                                                                        onClick={() => {
                                                                                            setSelectedUserBranch(userBranch.id)
                                                                                            setSelectedBranchId(userBranch.id)
                                                                                            setSelectedBranchName(userBranch.name)
                                                                                            setSelectedBranchLevel(userBranch.level)
                                                                                            setSelectedBranchQueueType(userBranch.branchQueueType)
                                                                                        }}
                                                                                    >
                                                                                        <div
                                                                                            className='d-flex justify-content-between'>
                                                                                            <div>{userBranch.name}</div>
                                                                                            <div
                                                                                                className={selectedBranchId === userBranch.id ? 'btn btn-prymary select-btn external-link-active'
                                                                                                    : 'btn btn-prymary select-btn'}>
                                                                                                <i className="fa fa-external-link float-left"></i>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                ) : (<div
                                                                                    className='dd-handle align-items-center'
                                                                                    style={{cursor: 'default'}}
                                                                                >
                                                                                    <div
                                                                                        className='d-flex justify-content-between'>
                                                                                        <div>{userBranch.name}</div>
                                                                                    </div>
                                                                                </div>)}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Accordion.Collapse>
                                                </div>
                                            </Accordion>
                                        </div>

                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                ) : (null)}

            </>

            <div
                className={`${sticky ? "block-header block-header-padding sticky" : "block-header block-header-padding"}`}>
                <div className="row clearfix">


                    {selectedBranchLevel === 1000 ? (
                            <div
                                className="col-md-6 col-sm-12 text-right hidden-xs d-flex align-items-center justify-content-end w-100 mb-2">
                                {/* {isRunning &&  <p className='my-0 py-0 mx-4'>Countdown: {formatTime(time)}</p>} */}

                                {/* <button className={`btn btn-sm ${isRunning ? "btn-secondary": "btn-success" } mr-2`}
                                    type="button"
                                    title={`View Branch Table`}
                                    disabled={isRunning}
                                    onClick={() => {
                                       restart();
                                    }}
                                > Activate
                                </button> */}

                                {/*<button className="btn btn-sm btn-primary"*/}
                                {/*        type="button"*/}
                                {/*        title={`View Branch Table`}*/}
                                {/*        onClick={() => {*/}
                                {/*            navigateToBranchTables(selectedBranchId, selectedBranchName, selectedBranchLevel, selectedBranchQueueType)*/}
                                {/*        }}*/}
                                {/*>Branch Tables*/}
                                {/*</button>*/}

                            </div>
                        ) :
                        (
                            <div className="mb-3 mr-1 mb-4 col-12 text-right">
                                <div className="d-flex justify-content-lg-end gap-3 mb-3">
                                    {/* Start Date Picker */}
                                    {/*<div>*/}
                                    {/*    <label className="form-label d-block mb-1">Select Start Date</label>*/}
                                    {/*    <DatePicker*/}
                                    {/*        selected={startDate}*/}
                                    {/*        onChange={(date) => {*/}
                                    {/*            setStartDate(date);*/}

                                    {/*            const nextDay = new Date(date);*/}
                                    {/*            nextDay.setDate(date.getDate() + 1);*/}

                                    {/*            if (!endDate || date >= endDate) {*/}
                                    {/*                setEndDate(nextDay); // auto-set to startDate + 1 day*/}
                                    {/*            }*/}
                                    {/*        }}*/}
                                    {/*        startDate={startDate}*/}
                                    {/*        endDate={endDate}*/}
                                    {/*        dateFormat="yyyy-MM-dd"*/}
                                    {/*        placeholderText="Start Date"*/}
                                    {/*        maxDate={new Date()}*/}
                                    {/*        className="form-control"*/}
                                    {/*    />*/}
                                    {/*</div>*/}

                                    {/*/!* End Date Picker *!/*/}
                                    {/*<div>*/}
                                    {/*    <label className="form-label d-block mb-1">Select End Date</label>*/}
                                    {/*    <DatePicker*/}
                                    {/*        selected={endDate}*/}
                                    {/*        onChange={(date) => setEndDate(date)}*/}
                                    {/*        selectsEnd*/}
                                    {/*        startDate={startDate}*/}
                                    {/*        endDate={endDate}*/}
                                    {/*        minDate={startDate}*/}
                                    {/*        maxDate={new Date()}*/}
                                    {/*        dateFormat="yyyy-MM-dd"*/}
                                    {/*        placeholderText="End Date"*/}
                                    {/*        className="form-control"*/}
                                    {/*    />*/}
                                    {/*</div>*/}

                                    {/* Start Date Picker */}
                                    <div>
                                        <label className="form-label d-block mb-1">Select Start Date</label>
                                        <DatePicker
                                            selected={startDate}
                                            onChange={handleStartDateChange}
                                            dateFormat="yyyy-MM-dd"
                                            maxDate={new Date()}
                                            placeholderText="Start Date"
                                            className="form-control"
                                        />
                                    </div>

                                    {/* End Date Display (Read-Only) */}
                                    <div>
                                        <label className="form-label d-block mb-1">End Date (auto-calculated)</label>
                                        <DatePicker
                                            selected={endDate}
                                            dateFormat="yyyy-MM-dd"
                                            placeholderText="End Date"
                                            className="form-control"
                                            readOnly
                                        />
                                    </div>

                                </div>

                                <div className="mt-2">
                                    {/*<div>Start Date: {startDate?.toDateString()}</div>*/}
                                    {/*/!*{endDate && <div>End Date: {endDate.toDateString()}</div>}*!/*/}
                                </div>
                            </div>
                        )}
                </div>
            </div>

            <div className="container-fluid branch-dashboard mt-4">


                <Block>

                    <Row className="g-gs mt-3">
                        <Col md="4">
                            <PreviewAltCard className="card-full">
                                <div className="card-title-group align-start mb-0">
                                    <div className="card-title">
                                        <h6 className="subtitle">Total Visitors</h6>
                                    </div>

                                    <div className="card-tools">
                                        <TooltipComponent
                                            iconClass="card-hint"
                                            icon="help-fill"
                                            direction="left"
                                            id="tooltip-total-visitors"
                                            text="Total Visitors"
                                        />

                                    </div>

                                </div>

                                <div className="card-amount">
                  <span className="amount">
                    {totalVisitor.toLocaleString()} <span className="currency currency-usd">Visitors</span>
                  </span>

                                    {/*                                    <span>*/}
                                    {/*  {lastDayVisitors && allDayVisitors > 0 ? (*/}
                                    {/*      <>*/}
                                    {/*          {allDayVisitors >= lastDayVisitors ? (*/}
                                    {/*              <Icon name="arrow-long-up"></Icon>*/}
                                    {/*          ) : (*/}
                                    {/*              <Icon name="arrow-long-down"></Icon>*/}
                                    {/*          )}*/}
                                    {/*          {Math.abs(((allDayVisitors - lastDayVisitors) / lastDayVisitors) * 100).toFixed(2)}%*/}
                                    {/*      </>*/}
                                    {/*  ) : (*/}
                                    {/*      <span className="text-muted"></span>*/}
                                    {/*  )}*/}
                                    {/*</span>*/}
                                </div>
                                {/*           <div className="invest-data">*/}
                                {/*               <div className="invest-data-amount g-2">*/}
                                {/*                   <div className="invest-data-history">*/}
                                {/*                       <div className="title">This Month</div>*/}
                                {/*                       <span className="amount">*/}
                                {/*2344 <span className="currency currency-usd"> Visitors</span>*/}
                                {/* </span>*/}
                                {/*                   </div>*/}
                                {/*                   <div className="invest-data-history">*/}
                                {/*                       <div className="title">This Week</div>*/}
                                {/*                       <span className="amount">*/}
                                {/*  {lastWeekVisitors.toLocaleString()} <span className="currency currency-usd"> Visitors</span>*/}
                                {/* </span>*/}
                                {/*                   </div>*/}
                                {/*               </div>*/}
                                {/*               <div className="invest-data-ck">*/}
                                {/*                   <DepositBarChart chartData={chartData}/>*/}
                                {/*               </div>*/}
                                {/*           </div>*/}

                            </PreviewAltCard>

                        </Col>
                        <Col md="4">
                            <PreviewAltCard className="card-full">
                                <div className="card-title-group align-start mb-0">
                                    <div className="card-title">
                                        <h6 className="subtitle">Total Served</h6>
                                    </div>

                                    <div className="card-tools">
                                        <TooltipComponent
                                            iconClass="card-hint"
                                            icon="help-fill"
                                            direction="left"
                                            id="tooltip-total-served"
                                            text="Total Served"
                                        />
                                    </div>

                                </div>

                                <div className="card-amount">
                  <span className="amount">
                    {totalServed.toLocaleString()} <span className="currency currency-usd"></span>
                  </span>

                                    {/*                                    <span>*/}
                                    {/*  {lastDayVisitors && allDayVisitors > 0 ? (*/}
                                    {/*      <>*/}
                                    {/*          {allDayVisitors >= lastDayVisitors ? (*/}
                                    {/*              <Icon name="arrow-long-up"></Icon>*/}
                                    {/*          ) : (*/}
                                    {/*              <Icon name="arrow-long-down"></Icon>*/}
                                    {/*          )}*/}
                                    {/*          {Math.abs(((allDayVisitors - lastDayVisitors) / lastDayVisitors) * 100).toFixed(2)}%*/}
                                    {/*      </>*/}
                                    {/*  ) : (*/}
                                    {/*      <span className="text-muted"></span>*/}
                                    {/*  )}*/}
                                    {/*</span>*/}
                                </div>
                                {/*           <div className="invest-data">*/}
                                {/*               <div className="invest-data-amount g-2">*/}
                                {/*                   <div className="invest-data-history">*/}
                                {/*                       <div className="title">This Month</div>*/}
                                {/*                       <span className="amount">*/}
                                {/*2344 <span className="currency currency-usd"> Visitors</span>*/}
                                {/* </span>*/}
                                {/*                   </div>*/}
                                {/*                   <div className="invest-data-history">*/}
                                {/*                       <div className="title">This Week</div>*/}
                                {/*                       <span className="amount">*/}
                                {/*  {lastWeekVisitors.toLocaleString()} <span className="currency currency-usd"> Visitors</span>*/}
                                {/* </span>*/}
                                {/*                   </div>*/}
                                {/*               </div>*/}
                                {/*               <div className="invest-data-ck">*/}
                                {/*                   <DepositBarChart chartData={chartData}/>*/}
                                {/*               </div>*/}
                                {/*           </div>*/}

                            </PreviewAltCard>

                        </Col>
                        <Col md="4">
                            <PreviewAltCard className="card-full">
                                <div className="card-title-group align-start mb-0">
                                    <div className="card-title">
                                        <h6 className="subtitle">No Show</h6>
                                    </div>

                                    <div className="card-tools">
                                        <TooltipComponent
                                            iconClass="card-hint"
                                            icon="help-fill"
                                            direction="left"
                                            id="tooltip-no-show"
                                            text="No Show"
                                        />
                                    </div>

                                </div>

                                <div className="card-amount">
                  <span className="amount">
                    {totalNoShow.toLocaleString()} <span className="currency currency-usd"></span>
                  </span>

                                    {/*                                    <span>*/}
                                    {/*  {lastDayVisitors && allDayVisitors > 0 ? (*/}
                                    {/*      <>*/}
                                    {/*          {allDayVisitors >= lastDayVisitors ? (*/}
                                    {/*              <Icon name="arrow-long-up"></Icon>*/}
                                    {/*          ) : (*/}
                                    {/*              <Icon name="arrow-long-down"></Icon>*/}
                                    {/*          )}*/}
                                    {/*          {Math.abs(((allDayVisitors - lastDayVisitors) / lastDayVisitors) * 100).toFixed(2)}%*/}
                                    {/*      </>*/}
                                    {/*  ) : (*/}
                                    {/*      <span className="text-muted"></span>*/}
                                    {/*  )}*/}
                                    {/*</span>*/}
                                </div>
                                {/*           <div className="invest-data">*/}
                                {/*               <div className="invest-data-amount g-2">*/}
                                {/*                   <div className="invest-data-history">*/}
                                {/*                       <div className="title">This Month</div>*/}
                                {/*                       <span className="amount">*/}
                                {/*2344 <span className="currency currency-usd"> Visitors</span>*/}
                                {/* </span>*/}
                                {/*                   </div>*/}
                                {/*                   <div className="invest-data-history">*/}
                                {/*                       <div className="title">This Week</div>*/}
                                {/*                       <span className="amount">*/}
                                {/*  {lastWeekVisitors.toLocaleString()} <span className="currency currency-usd"> Visitors</span>*/}
                                {/* </span>*/}
                                {/*                   </div>*/}
                                {/*               </div>*/}
                                {/*               <div className="invest-data-ck">*/}
                                {/*                   <DepositBarChart chartData={chartData}/>*/}
                                {/*               </div>*/}
                                {/*           </div>*/}

                            </PreviewAltCard>

                        </Col>

                    </Row>
                </Block>


                <Block>
                    <Row className="g-gs">
                        <Col md="4">
                            <PreviewAltCard className="card-full">
                                <div className="card-title-group align-start mb-0">
                                    <div className="card-title">
                                        <h6 className="subtitle">Service Exception</h6>
                                    </div>

                                    <div className="card-tools">
                                        <TooltipComponent
                                            iconClass="card-hint"
                                            icon="help-fill"
                                            direction="left"
                                            id="tooltip-service-exception"
                                            text="Service Exception"
                                        />
                                    </div>

                                </div>

                                <div className="card-amount">
                  <span className="amount">
                    {serviceException[0]} <span className="currency currency-usd"></span>
                  </span>

                                    {/*                                    <span>*/}
                                    {/*  {serviceException[1] && serviceException[0]> 0 ? (*/}
                                    {/*      <>*/}
                                    {/*          {serviceException[0] >= serviceException[1] ? (*/}
                                    {/*              <Icon name="arrow-long-up"></Icon>*/}
                                    {/*          ) : (*/}
                                    {/*              <Icon name="arrow-long-down"></Icon>*/}
                                    {/*          )}*/}
                                    {/*          {Math.abs(((serviceException[0] - serviceException[1]) / serviceException[1]) * 100).toFixed(2)}%*/}
                                    {/*      </>*/}
                                    {/*  ) : (*/}
                                    {/*      <span className="text-muted"></span>*/}
                                    {/*  )}*/}
                                    {/*</span>*/}
                                </div>
                                <div className="invest-data">
                                    <div className="invest-data-amount g-2">
                                        <div className="invest-data-history">
                                            <div className="title">Max Served Time</div>
                                            <div>
 <span
     className="amount"
     data-tip={` ${serviceException[3]}<br/>Branch Name:${serviceException[11]}<br/>Ticket Number: ${serviceException[5]}<br/>Counter: ${serviceException[7]}<br/>Teller Name: ${serviceException[9]}`}
     data-html={true}
 >
  {serviceException[1]} <span className="currency currency-usd"> </span>
</span>

                                                {/* Add this once, at the root of your component or page */}
                                                <ReactTooltip effect="float" html={true} place="bottom"/>

                                            </div>
                                        </div>
                                        <div className="invest-data-history">
                                            <div className="title">Min Served Time</div>
                                            <span
                                                className="amount"
                                                data-tip={` ${serviceException[4]}<br/>Branch Name:${serviceException[12]}<br/>Ticket Number: ${serviceException[6]}<br/>Counter: ${serviceException[8]}<br/>Teller Name: ${serviceException[10]}`}
                                                data-html={true}
                                            >
  {serviceException[2]} <span className="currency currency-usd"> </span>
</span>

                                            <ReactTooltip effect="float" place="bottom"/>

                                        </div>
                                    </div>
                                    <div className="invest-data-ck">
                                        {/*<DepositBarChart chartData={chartData}/>*/}
                                    </div>
                                </div>

                            </PreviewAltCard>

                        </Col>
                        <Col md="4">
                            <PreviewAltCard className="card-full">
                                <div className="card-title-group align-start mb-0">
                                    <div className="card-title">
                                        <h6 className="subtitle">Waiting Exception</h6>
                                    </div>

                                    <div className="card-tools">
                                        <TooltipComponent
                                            iconClass="card-hint"
                                            icon="help-fill"
                                            direction="left"
                                            id="tooltip-waiting-exception"
                                            text="Waiting Exception"
                                        />
                                    </div>

                                </div>

                                <div className="card-amount">
                  <span className="amount">
                    {waitingException[0]} <span className="currency currency-usd"></span>
                  </span>

                                    {/*                                    <span>*/}
                                    {/*  {waitingException[1] && waitingException[0]> 0 ? (*/}
                                    {/*      <>*/}
                                    {/*          {waitingException[0] >= waitingException[1] ? (*/}
                                    {/*              <Icon name="arrow-long-up"></Icon>*/}
                                    {/*          ) : (*/}
                                    {/*              <Icon name="arrow-long-down"></Icon>*/}
                                    {/*          )}*/}
                                    {/*          {Math.abs(((waitingException[0] - waitingException[1]) / waitingException[1]) * 100).toFixed(2)}%*/}
                                    {/*      </>*/}
                                    {/*  ) : (*/}
                                    {/*      <span className="text-muted"></span>*/}
                                    {/*  )}*/}
                                    {/*</span>*/}
                                </div>
                                <div className="invest-data">
                                    <div className="invest-data-amount g-2">
                                        <div className="invest-data-history">
                                            <div className="title">Max Waiting Time</div>
                                            <span className="amount"
                                                  data-tip={` ${waitingException[3]}<br/>Branch Name:${waitingException[7]}<br/>Ticket Number: ${waitingException[5]}`}
                                                  data-html={true}

                                            >
                      {waitingException[1]} <span className="currency currency-usd"> </span>
                      </span>
                                            <ReactTooltip effect="float" html="true" place="bottom"/>
                                        </div>
                                        <div className="invest-data-history">
                                            <div className="title">Min Waiting Time</div>
                                            <span className="amount"
                                                  data-tip={` ${waitingException[4]}<br/>Branch Name:${waitingException[8]}<br/>Ticket Number: ${waitingException[6]}`}
                                                  data-html={true}

                                            >
                       {waitingException[2]} <span className="currency currency-usd"> </span>
                      </span>
                                            <ReactTooltip effect="float" place="bottom"/>
                                        </div>
                                    </div>
                                    <div className="invest-data-ck">
                                        {/*<DepositBarChart chartData={chartData}/>*/}
                                    </div>
                                </div>

                            </PreviewAltCard>

                        </Col>
                        <Col md="4">
                            <PreviewAltCard className="card-full">
                                <div className="card-title-group align-start mb-0">
                                    <div className="card-title">
                                        <h6 className="subtitle">AVG Spent Time</h6>
                                    </div>

                                    <div className="card-tools">
                                        <TooltipComponent
                                            iconClass="card-hint"
                                            icon="help-fill"
                                            direction="left"
                                            id="tooltip-avg-spent-time"
                                            text="AVG Spent Time"
                                        />
                                    </div>

                                </div>

                                <div className="card-amount">
                  <span className="amount">
                    {spentTime[0]} <span className="currency currency-usd"></span>
                  </span>

                                    {/*                                    <span>*/}
                                    {/*  {spentTime[5] && spentTime[4]> 0 ? (*/}
                                    {/*      <>*/}
                                    {/*          {spentTime[4] >= spentTime[5] ? (*/}
                                    {/*              <Icon name="arrow-long-up"></Icon>*/}
                                    {/*          ) : (*/}
                                    {/*              <Icon name="arrow-long-down"></Icon>*/}
                                    {/*          )}*/}
                                    {/*          {Math.abs(((spentTime[4] - spentTime[5]) / spentTime[5]) * 100).toFixed(2)}%*/}
                                    {/*      </>*/}
                                    {/*  ) : (*/}
                                    {/*      <span className="text-muted"></span>*/}
                                    {/*  )}*/}
                                    {/*</span>*/}
                                </div>
                                <div className="invest-data">
                                    <div className="invest-data-amount g-2">
                                        <div className="invest-data-history">
                                            <div className="title">Max Spent Time</div>
                                            <span className="amount"
                                                  data-tip={`${spentTime[3]}`}>
                      {spentTime[1]} <span className="currency currency-usd"> </span>
                      </span>
                                            <ReactTooltip effect="float" place="bottom"/>
                                        </div>
                                        <div className="invest-data-history">
                                            <div className="title">Min Spent Time</div>
                                            <span className="amount"
                                                  data-tip={`${spentTime[4]}`}>
                       {spentTime[2]} <span className="currency currency-usd"> </span>
                      </span>
                                            <ReactTooltip effect="float" place="bottom"/>
                                        </div>
                                    </div>
                                    <div className="invest-data-ck">
                                        {/*<DepositBarChart chartData={chartData}/>*/}
                                    </div>
                                </div>

                            </PreviewAltCard>

                        </Col>
                        {/*                        <Col md="4">*/}
                        {/*                            <PreviewAltCard className="card-full">*/}
                        {/*                                <div className="card-title-group align-start mb-0">*/}
                        {/*                                    <div className="card-title">*/}
                        {/*                                        <h6 className="subtitle">Waiting Exception</h6>*/}
                        {/*                                    </div>*/}

                        {/*                                    <div className="card-tools">*/}
                        {/*                                        <TooltipComponent*/}
                        {/*                                            iconClass="card-hint"*/}
                        {/*                                            icon="help-fill"*/}
                        {/*                                            direction="left"*/}
                        {/*                                            id="invest-deposit"*/}
                        {/*                                            text="Total Deposited"*/}
                        {/*                                        ></TooltipComponent>*/}
                        {/*                                    </div>*/}

                        {/*                                </div>*/}

                        {/*                                <div className="card-amount">*/}
                        {/*                  <span className="amount">*/}
                        {/*                    {waitingException[0]} <span className="currency currency-usd"></span>*/}
                        {/*                  </span>*/}

                        {/*                                    <span>*/}
                        {/*  {waitingException[1] && waitingException[0]> 0 ? (*/}
                        {/*      <>*/}
                        {/*          {waitingException[0] >= waitingException[1] ? (*/}
                        {/*              <Icon name="arrow-long-up"></Icon>*/}
                        {/*          ) : (*/}
                        {/*              <Icon name="arrow-long-down"></Icon>*/}
                        {/*          )}*/}
                        {/*          {Math.abs(((waitingException[0] - waitingException[1]) / waitingException[1]) * 100).toFixed(2)}%*/}
                        {/*      </>*/}
                        {/*  ) : (*/}
                        {/*      <span className="text-muted"></span>*/}
                        {/*  )}*/}
                        {/*</span>*/}
                        {/*                                </div>*/}
                        {/*                                <div className="invest-data">*/}
                        {/*                                    <div className="invest-data-amount g-2">*/}
                        {/*                                        <div className="invest-data-history">*/}
                        {/*                                            <div className="title">Max Waiting Time</div>*/}
                        {/*                                            <span className="amount">*/}
                        {/*                      {waitingException[2]} <span className="currency currency-usd"> </span>*/}
                        {/*                      </span>*/}
                        {/*                                        </div>*/}
                        {/*                                        <div className="invest-data-history">*/}
                        {/*                                            <div className="title">Min Waiting Time</div>*/}
                        {/*                                            <span className="amount">*/}
                        {/*                       {waitingException[3]} <span className="currency currency-usd"> </span>*/}
                        {/*                      </span>*/}
                        {/*                                        </div>*/}
                        {/*                                    </div>*/}
                        {/*                                    <div className="invest-data-ck">*/}
                        {/*                                        /!*<DepositBarChart chartData={chartData}/>*!/*/}
                        {/*                                    </div>*/}
                        {/*                                </div>*/}

                        {/*                            </PreviewAltCard>*/}

                        {/*                        </Col>*/}
                        {/*                        <Col md="4">*/}
                        {/*                            <PreviewAltCard className="card-full">*/}
                        {/*                                <div className="card-title-group align-start mb-0">*/}
                        {/*                                    <div className="card-title">*/}
                        {/*                                        <h6 className="subtitle">AVG Spent Time</h6>*/}
                        {/*                                    </div>*/}

                        {/*                                    <div className="card-tools">*/}
                        {/*                                        <TooltipComponent*/}
                        {/*                                            iconClass="card-hint"*/}
                        {/*                                            icon="help-fill"*/}
                        {/*                                            direction="left"*/}
                        {/*                                            id="invest-deposit"*/}
                        {/*                                            text="Total Deposited"*/}
                        {/*                                        ></TooltipComponent>*/}
                        {/*                                    </div>*/}

                        {/*                                </div>*/}

                        {/*                                <div className="card-amount">*/}
                        {/*                  <span className="amount">*/}
                        {/*                    {spentTime[0]} <span className="currency currency-usd"></span>*/}
                        {/*                  </span>*/}

                        {/*                                    <span>*/}
                        {/*  {spentTime[5] && spentTime[4]> 0 ? (*/}
                        {/*      <>*/}
                        {/*          {spentTime[4] >= spentTime[5] ? (*/}
                        {/*              <Icon name="arrow-long-up"></Icon>*/}
                        {/*          ) : (*/}
                        {/*              <Icon name="arrow-long-down"></Icon>*/}
                        {/*          )}*/}
                        {/*          {Math.abs(((spentTime[4] - spentTime[5]) / spentTime[5]) * 100).toFixed(2)}%*/}
                        {/*      </>*/}
                        {/*  ) : (*/}
                        {/*      <span className="text-muted"></span>*/}
                        {/*  )}*/}
                        {/*</span>*/}
                        {/*                                </div>*/}
                        {/*                                <div className="invest-data">*/}
                        {/*                                    <div className="invest-data-amount g-2">*/}
                        {/*                                        <div className="invest-data-history">*/}
                        {/*                                            <div className="title">Max Spent Time</div>*/}
                        {/*                                            <span className="amount">*/}
                        {/*                      {spentTime[2]} <span className="currency currency-usd"> </span>*/}
                        {/*                      </span>*/}
                        {/*                                        </div>*/}
                        {/*                                        <div className="invest-data-history">*/}
                        {/*                                            <div className="title">Min Spent Time</div>*/}
                        {/*                                            <span className="amount">*/}
                        {/*                       {spentTime[3]} <span className="currency currency-usd"> </span>*/}
                        {/*                      </span>*/}
                        {/*                                        </div>*/}
                        {/*                                    </div>*/}
                        {/*                                    <div className="invest-data-ck">*/}
                        {/*                                        /!*<DepositBarChart chartData={chartData}/>*!/*/}
                        {/*                                    </div>*/}
                        {/*                                </div>*/}

                        {/*                            </PreviewAltCard>*/}

                        {/*                        </Col>*/}

                    </Row>

                </Block>

                <Block>
                    <Row className="g-gs">
                        {/* First column: 3/4 width */}
                        {/*              <Col md="6">*/}
                        {/*                  <PreviewAltCard className="card-full">*/}
                        {/*                      <div className="card-title-group align-start mb-0">*/}
                        {/*                          <div className="card-title">*/}
                        {/*                              <h6 className="subtitle">Total Visitors</h6>*/}
                        {/*                          </div>*/}
                        {/*                          <div className="card-tools">*/}
                        {/*                              <TooltipComponent*/}
                        {/*                                  iconClass="card-hint"*/}
                        {/*                                  icon="help-fill"*/}
                        {/*                                  direction="left"*/}
                        {/*                                  id="invest-deposit"*/}
                        {/*                                  text="Total Deposited"*/}
                        {/*                              />*/}
                        {/*                          </div>*/}
                        {/*                      </div>*/}
                        {/*                      <div className="card-amount">*/}
                        {/*<span className="amount">*/}
                        {/*  {totalVisitor.toLocaleString()} <span className="currency currency-usd">Visitors</span>*/}
                        {/*</span>*/}
                        {/*                      </div>*/}
                        {/*                      <div className="nk-sales-ck large pt-4">*/}
                        {/*                          {dailyTotalVisitors.length > 0 ? (*/}
                        {/*                              <LineChart1 chartData={dailyTotalVisitors}/>*/}
                        {/*                          ) : (*/}
                        {/*                              <div style={{textAlign: 'center', padding: '2rem', color: '#9eaecf'}}>*/}
                        {/*                                  No data available*/}
                        {/*                              </div>*/}
                        {/*                          )}*/}
                        {/*                      </div>*/}
                        {/*                  </PreviewAltCard>*/}
                        {/*              </Col>*/}

                        {/* Second & Third column: 1/4 width stacked vertically */}
                        {/*              <Col md="6">*/}
                        {/*                  <Row className="g-gs flex-column">*/}
                        {/*                      <Col>*/}
                        {/*                          <PreviewAltCard className="card-full">*/}
                        {/*                              /!* Title + Chart Row *!/*/}
                        {/*                              <div className="d-flex align-items-start justify-between flex-wrap">*/}
                        {/*                                  /!* Title and Tooltip *!/*/}
                        {/*                                  <div style={{ paddingRight: "1rem" }}>*/}
                        {/*                                      <div className="card-title d-flex align-items-center mb-1">*/}
                        {/*                                          <h6 className="subtitle mb-0" >AVG Service Time</h6>*/}
                        {/*                                          <TooltipComponent*/}
                        {/*                                              iconClass="card-hint"*/}
                        {/*                                              icon="help-fill"*/}
                        {/*                                              direction="left"*/}
                        {/*                                              id="invest-deposit"*/}
                        {/*                                              text="Total Deposited"*/}
                        {/*                                          />*/}
                        {/*                                      </div>*/}
                        {/*                                      /!* AVG Value *!/*/}
                        {/*                                      <div className="card-amount">*/}
                        {/*<span className="amount" >*/}
                        {/*  {avgServiceTime} <span className="currency currency-usd"></span>*/}
                        {/*</span>*/}
                        {/*                                      </div>*/}
                        {/*                                  </div>*/}

                        {/*                                  /!* Chart *!/*/}
                        {/*                                  <div style={{ flex: 1, minWidth: "250px", height: "130px" }}>*/}
                        {/*                                      {dailyTotalVisitors.length > 0 ? (*/}
                        {/*                                          <LineChart2 chartData={dailyAvgServiceTime} />*/}
                        {/*                                      ) : (*/}
                        {/*                                          <div style={{ textAlign: 'center', padding: '2rem', color: '#9eaecf' }}>*/}
                        {/*                                              No data available*/}
                        {/*                                          </div>*/}
                        {/*                                      )}*/}
                        {/*                                  </div>*/}
                        {/*                              </div>*/}
                        {/*                          </PreviewAltCard>*/}
                        {/*                      </Col>*/}

                        {/*                      <Col>*/}
                        {/*                          <PreviewAltCard className="card-full">*/}
                        {/*                              /!* Title + Chart Row *!/*/}
                        {/*                              <div className="d-flex align-items-start justify-between flex-wrap">*/}
                        {/*                                  /!* Title and Tooltip *!/*/}
                        {/*                                  <div style={{ paddingRight: "1rem" }}>*/}
                        {/*                                      <div className="card-title d-flex align-items-center mb-1">*/}
                        {/*                                          <h6 className="subtitle mb-0" >AVG Wait Time</h6>*/}
                        {/*                                          <TooltipComponent*/}
                        {/*                                              iconClass="card-hint"*/}
                        {/*                                              icon="help-fill"*/}
                        {/*                                              direction="left"*/}
                        {/*                                              id="invest-deposit"*/}
                        {/*                                              text="Total Deposited"*/}
                        {/*                                          />*/}
                        {/*                                      </div>*/}
                        {/*                                      /!* AVG Value *!/*/}
                        {/*                                      <div className="card-amount">*/}
                        {/*<span className="amount" >*/}
                        {/*  {avgWaitTime} <span className="currency currency-usd"></span>*/}
                        {/*</span>*/}
                        {/*                                      </div>*/}
                        {/*                                  </div>*/}

                        {/*                                  /!* Chart *!/*/}
                        {/*                                  <div style={{ flex: 1, minWidth: "250px", height: "130px" }}>*/}
                        {/*                                      {dailyTotalVisitors.length > 0 ? (*/}
                        {/*                                          <LineChart2 chartData={dailyAvgWaitTime} />*/}
                        {/*                                      ) : (*/}
                        {/*                                          <div style={{ textAlign: 'center', padding: '2rem', color: '#9eaecf' }}>*/}
                        {/*                                              No data available*/}
                        {/*                                          </div>*/}
                        {/*                                      )}*/}
                        {/*                                  </div>*/}
                        {/*                              </div>*/}
                        {/*                          </PreviewAltCard>*/}
                        {/*                      </Col>*/}
                        {/*                  </Row>*/}
                        {/*              </Col>*/}
                    </Row>
                </Block>

                <React.Fragment>
                    <div className="card-title-group align-start gx-3 mb-3 mt-4">
                        <div className="card-title">
                            <h6 className="title">Service Overview ( {serviceUsers} <small>Visitors</small> )</h6>
                            <p>
                                Service Overview
                            </p>
                        </div>
                        <div className="card-tools m-3">
                            <UncontrolledDropdown>
                                <DropdownToggle tag="div" color="transparent">
                                    <a
                                        href="#toggle"
                                        onClick={(ev) => ev.preventDefault()}
                                        className="btn btn-primary btn-dim d-none d-sm-inline-flex"
                                    >
                                        <Icon className="d-none d-sm-inline" name="download-cloud"/>
                                        <span>
                <span className="d-none d-md-inline">
                    {selectedServices
                        ? allService.find(s => s.id === selectedServices)?.name
                        : "Select Service"}

                </span>
            </span>
                                    </a>
                                    <a
                                        href="#toggle"
                                        onClick={(ev) => ev.preventDefault()}
                                        className="btn btn-primary btn-icon btn-dim d-sm-none"
                                    >
                                        <Icon name="download-cloud"/>
                                    </a>
                                </DropdownToggle>

                                <DropdownMenu end>
                                    <ul className="link-list-opt no-bdr">
                                        {allService.map((service) => (
                                            <li key={service.id}>
                                                <DropdownItem
                                                    tag="a"
                                                    href="#dropdownitem"
                                                    onClick={(ev) => {
                                                        ev.preventDefault();
                                                        setSelectedServices(service.id); // Set selected service id
                                                    }}
                                                >
                                                    <span>{service.name}</span>
                                                </DropdownItem>
                                            </li>
                                        ))}
                                    </ul>
                                </DropdownMenu>
                            </UncontrolledDropdown>

                        </div>
                    </div>
                    {/*                <div className="flex justify-between items-center gap-4">*/}
                    {/*                    /!* Left block: 4 AVG Service Time items *!/*/}
                    {/*                    <div className="flex gap-4">*/}
                    {/*                        <div className="card-title">*/}
                    {/*                            <h6 className="subtitle">AVG Service Time</h6>*/}
                    {/*                            <span className="amount font-bold">{serviceWaitTimeAvg}</span>*/}
                    {/*                        </div>*/}

                    {/*                        <div className="card-title">*/}
                    {/*                            <h6 className="subtitle">AVG Spent Time</h6>*/}
                    {/*                            <span className="amount font-bold">{spent}</span>*/}
                    {/*                        </div>*/}
                    {/*                        <div className="card-title">*/}
                    {/*                            <h6 className="subtitle">Waiting Exception</h6>*/}
                    {/*                            <span className="amount font-bold">{waitE}</span>*/}
                    {/*                        </div>*/}
                    {/*                        <div className="card-title">*/}
                    {/*                            <h6 className="subtitle">Service Exception</h6>*/}
                    {/*                            <span className="amount font-bold">{serviceE}</span>*/}
                    {/*                        </div>*/}
                    {/*                    </div>*/}

                    {/*                    /!* Right block: Visitors *!/*/}
                    {/*                    <div className="nk-sale-data">*/}
                    {/*<span className="amount sm">*/}
                    {/*  {serviceUsers} <small>Visitors</small>*/}
                    {/*</span>*/}
                    {/*                    </div>*/}
                    {/*                </div>*/}

                    <div className="analytic-data-group analytic-ov-group g-3">
                        <div className="analytic-data analytic-ov-data">
                            <div className="title">AVG Served Time</div>
                            <div className="amount">{serviceWaitTimeAvg}</div>
                            <div className="change up">
                            </div>
                        </div>
                        <div className="analytic-data analytic-ov-data">
                            <div className="title">AVG Spent Time</div>
                            <div className="amount">{spent}</div>
                            <div className="change up">
                            </div>
                        </div>
                        <div className="analytic-data analytic-ov-data">
                            <div className="title">Waiting Exception</div>
                            <div className="amount">{waitE}</div>
                            <div className="change down">
                            </div>
                        </div>
                        <div className="analytic-data analytic-ov-data">
                            <div className="title">Service Exception</div>
                            <div className="amount">{serviceE}</div>
                            <div className="change down">

                            </div>
                        </div>

                    </div>

                    <div className="nk-sales-ck large pt-4">
                        {visitorData.length > 0 ? (
                            // <LineChart chartData={visitorData}/>
                            <AudienceLineChart4
                                waitTimeData={visitorData}
                                serviceTimeData={serviceByHourly}
                                waitingException={waitExceptionHourly}
                                serviceException={serviceExceptionHourly}
                            />
                        ) : (
                            <div style={{textAlign: 'center', padding: '2rem', color: '#9eaecf'}}>
                                No data available
                            </div>
                        )}
                    </div>

                </React.Fragment>
                <React.Fragment>
                    <div className="card-title-group align-start gx-3 mb-3 mt-4">
                        <div className="card-title">
                            <h6 className="title">Spent Time Overview </h6>
                            <p>
                                Spent Time Overview ( {selectedServiceName} )
                            </p>
                        </div>
                        <div className="card-tools m-3">
                            {/*                <UncontrolledDropdown>*/}
                            {/*                    <DropdownToggle tag="div" color="transparent">*/}
                            {/*                        <a*/}
                            {/*                            href="#toggle"*/}
                            {/*                            onClick={(ev) => ev.preventDefault()}*/}
                            {/*                            className="btn btn-primary btn-dim d-none d-sm-inline-flex"*/}
                            {/*                        >*/}
                            {/*                            <Icon className="d-none d-sm-inline" name="download-cloud"/>*/}
                            {/*                            <span>*/}
                            {/*    <span className="d-none d-md-inline">*/}
                            {/*        {selectedServices*/}
                            {/*            ? allService.find(s => s.id === selectedServices)?.name*/}
                            {/*            : "Select Service"}*/}

                            {/*    </span>*/}
                            {/*</span>*/}
                            {/*                        </a>*/}
                            {/*                        <a*/}
                            {/*                            href="#toggle"*/}
                            {/*                            onClick={(ev) => ev.preventDefault()}*/}
                            {/*                            className="btn btn-primary btn-icon btn-dim d-sm-none"*/}
                            {/*                        >*/}
                            {/*                            <Icon name="download-cloud"/>*/}
                            {/*                        </a>*/}
                            {/*                    </DropdownToggle>*/}

                            {/*                    <DropdownMenu end>*/}
                            {/*                        <ul className="link-list-opt no-bdr">*/}
                            {/*                            {allService.map((service) => (*/}
                            {/*                                <li key={service.id}>*/}
                            {/*                                    <DropdownItem*/}
                            {/*                                        tag="a"*/}
                            {/*                                        href="#dropdownitem"*/}
                            {/*                                        onClick={(ev) => {*/}
                            {/*                                            ev.preventDefault();*/}
                            {/*                                            setSelectedServices(service.id); // Set selected service id*/}
                            {/*                                        }}*/}
                            {/*                                    >*/}
                            {/*                                        <span>{service.name}</span>*/}
                            {/*                                    </DropdownItem>*/}
                            {/*                                </li>*/}
                            {/*                            ))}*/}
                            {/*                        </ul>*/}
                            {/*                    </DropdownMenu>*/}
                            {/*                </UncontrolledDropdown>*/}

                        </div>
                    </div>
                    {/*                <div className="flex justify-between items-center gap-4">*/}
                    {/*                    /!* Left block: 4 AVG Service Time items *!/*/}
                    {/*                    <div className="flex gap-4">*/}
                    {/*                        <div className="card-title">*/}
                    {/*                            <h6 className="subtitle">AVG Service Time</h6>*/}
                    {/*                            <span className="amount font-bold">{serviceWaitTimeAvg}</span>*/}
                    {/*                        </div>*/}

                    {/*                        <div className="card-title">*/}
                    {/*                            <h6 className="subtitle">AVG Spent Time</h6>*/}
                    {/*                            <span className="amount font-bold">{spent}</span>*/}
                    {/*                        </div>*/}
                    {/*                        <div className="card-title">*/}
                    {/*                            <h6 className="subtitle">Waiting Exception</h6>*/}
                    {/*                            <span className="amount font-bold">{waitE}</span>*/}
                    {/*                        </div>*/}
                    {/*                        <div className="card-title">*/}
                    {/*                            <h6 className="subtitle">Service Exception</h6>*/}
                    {/*                            <span className="amount font-bold">{serviceE}</span>*/}
                    {/*                        </div>*/}
                    {/*                    </div>*/}

                    {/*                    /!* Right block: Visitors *!/*/}
                    {/*                    <div className="nk-sale-data">*/}
                    {/*<span className="amount sm">*/}
                    {/*  {serviceUsers} <small>Visitors</small>*/}
                    {/*</span>*/}
                    {/*                    </div>*/}
                    {/*                </div>*/}


                    <div className="nk-sales-ck large pt-4">
                        {visitorData.length > 0 ? (
                            <LineChart6 chartData={spentHourly}/>
                            // <AudienceLineChart3
                            //     waitTimeData={visitorData}
                            //     serviceTimeData={serviceByHourly}
                            //     waitingException={waitExceptionHourly}
                            //     serviceException={serviceExceptionHourly}
                            // />
                        ) : (
                            <div style={{textAlign: 'center', padding: '2rem', color: '#9eaecf'}}>
                                No data available
                            </div>
                        )}
                    </div>

                </React.Fragment>

      {/*          <React.Fragment>*/}
      {/*              <div className="card-title-group align-start gx-3 mb-3 mt-4">*/}
      {/*                  <div className="card-title">*/}
      {/*                      <h6 className="title"> {selectedFunctionName} Overview </h6>*/}
      {/*                      <p>*/}
      {/*                          {selectedFunctionName} Overview ( {selectedServiceName} )*/}
      {/*                      </p>*/}
      {/*                  </div>*/}
      {/*                  <div className="card-tools m-3 d-flex align-items-start gap-lg-5 flex-wrap">*/}

      {/*                      /!* Date Picker *!/*/}
      {/*                      /!*<div>*!/*/}
      {/*                      /!*    <DatePicker*!/*/}
      {/*                      /!*        selected={selectDay2}*!/*/}
      {/*                      /!*        onChange={(date) => setSelectDay2(date)}*!/*/}
      {/*                      /!*        dateFormat="yyyy-MM-dd"*!/*/}
      {/*                      /!*        placeholderText="Select a date"*!/*/}
      {/*                      /!*        maxDate={*!/*/}
      {/*                      /!*            selectedDate*!/*/}
      {/*                      /!*                ? new Date(new Date(selectedDate).setDate(selectedDate.getDate() - 1))*!/*/}
      {/*                      /!*                : null*!/*/}
      {/*                      /!*        }*!/*/}
      {/*                      /!*        className="form-control"*!/*/}
      {/*                      /!*    />*!/*/}

      {/*                      /!*    <div className="mt-2">Selected Date: {selectDay2?.toDateString()}</div>*!/*/}
      {/*                      /!*</div>*!/*/}

      {/*                      /!* Service Dropdown *!/*/}
      {/*                      <UncontrolledDropdown>*/}
      {/*                          <DropdownToggle tag="div" color="transparent">*/}
      {/*                              <a*/}
      {/*                                  href="#toggle"*/}
      {/*                                  onClick={(ev) => ev.preventDefault()}*/}
      {/*                                  className="btn btn-primary btn-dim d-none d-sm-inline-flex"*/}
      {/*                              >*/}
      {/*                                  <Icon className="d-none d-sm-inline" name="download-cloud"/>*/}
      {/*                                  <span className="d-none d-md-inline">*/}
      {/*  {serviceFunctionMap.find((opt) => opt.value === selectFunction)?.label}*/}
      {/*</span>*/}
      {/*                              </a>*/}
      {/*                              <a*/}
      {/*                                  href="#toggle"*/}
      {/*                                  onClick={(ev) => ev.preventDefault()}*/}
      {/*                                  className="btn btn-primary btn-icon btn-dim d-sm-none"*/}
      {/*                              >*/}
      {/*                                  <Icon name="download-cloud"/>*/}
      {/*                              </a>*/}
      {/*                          </DropdownToggle>*/}

      {/*                          <DropdownMenu end>*/}
      {/*                              <ul className="link-list-opt no-bdr">*/}
      {/*                                  {serviceFunctionMap.map((opt) => (*/}
      {/*                                      <li key={opt.value}>*/}
      {/*                                          <DropdownItem*/}
      {/*                                              tag="a"*/}
      {/*                                              href="#select"*/}
      {/*                                              onClick={(ev) => {*/}
      {/*                                                  ev.preventDefault();*/}
      {/*                                                  setFunction(opt.value);*/}
      {/*                                              }}*/}
      {/*                                          >*/}
      {/*                                              <span>{opt.label}</span>*/}
      {/*                                          </DropdownItem>*/}
      {/*                                      </li>*/}
      {/*                                  ))}*/}
      {/*                              </ul>*/}
      {/*                          </DropdownMenu>*/}
      {/*                      </UncontrolledDropdown>*/}


      {/*                  </div>*/}

      {/*              </div>*/}
      {/*              /!*                <div className="flex justify-between items-center gap-4">*!/*/}
      {/*              /!*                    /!* Left block: 4 AVG Service Time items *!/*!/*/}
      {/*              /!*                    <div className="flex gap-4">*!/*/}
      {/*              /!*                        <div className="card-title">*!/*/}
      {/*              /!*                            <h6 className="subtitle">AVG Service Time</h6>*!/*/}
      {/*              /!*                            <span className="amount font-bold">{serviceWaitTimeAvg}</span>*!/*/}
      {/*              /!*                        </div>*!/*/}

      {/*              /!*                        <div className="card-title">*!/*/}
      {/*              /!*                            <h6 className="subtitle">AVG Spent Time</h6>*!/*/}
      {/*              /!*                            <span className="amount font-bold">{spent}</span>*!/*/}
      {/*              /!*                        </div>*!/*/}
      {/*              /!*                        <div className="card-title">*!/*/}
      {/*              /!*                            <h6 className="subtitle">Waiting Exception</h6>*!/*/}
      {/*              /!*                            <span className="amount font-bold">{waitE}</span>*!/*/}
      {/*              /!*                        </div>*!/*/}
      {/*              /!*                        <div className="card-title">*!/*/}
      {/*              /!*                            <h6 className="subtitle">Service Exception</h6>*!/*/}
      {/*              /!*                            <span className="amount font-bold">{serviceE}</span>*!/*/}
      {/*              /!*                        </div>*!/*/}
      {/*              /!*                    </div>*!/*/}

      {/*              /!*                    /!* Right block: Visitors *!/*!/*/}
      {/*              /!*                    <div className="nk-sale-data">*!/*/}
      {/*              /!*<span className="amount sm">*!/*/}
      {/*              /!*  {serviceUsers} <small>Visitors</small>*!/*/}
      {/*              /!*</span>*!/*/}
      {/*              /!*                    </div>*!/*/}
      {/*              /!*                </div>*!/*/}


      {/*              <div className="nk-sales-ck large pt-4">*/}
      {/*                  {visitorData.length > 0 || functionData.length > 0 ? (*/}
      {/*                      selectFunction === 5 ? (*/}
      {/*                          <LineChart9 data1={functionData1}*/}
      {/*                                      data2={functionData}*/}
      {/*                          />*/}
      {/*                      ) : (*/}
      {/*                          <LineChart8*/}
      {/*                              data1={functionData1}*/}
      {/*                              data2={functionData}*/}

      {/*                          />*/}

      {/*                      )*/}
      {/*                  ) : (*/}
      {/*                      <div style={{textAlign: 'center', padding: '2rem', color: '#9eaecf'}}>*/}
      {/*                          No data available*/}
      {/*                      </div>*/}
      {/*                  )}*/}
      {/*              </div>*/}


      {/*          </React.Fragment>*/}

            </div>
        </>
    );

};

export default AdvanceDashboardWeekly;